// @flow

import type { Action } from './store.type';

export const GET_SUGGESTIONS_REQUEST = 'GET_SUGGESTIONS_REQUEST';
type GET_SUGGESTIONS_REQUEST_TYPE = 'GET_SUGGESTIONS_REQUEST';

export const GET_SUGGESTIONS_SUCCESS = 'GET_SUGGESTIONS_SUCCESS';
type GET_SUGGESTIONS_SUCCESS_TYPE = 'GET_SUGGESTIONS_SUCCESS';

export const GET_SUGGESTIONS_FAILURE = 'GET_SUGGESTIONS_FAILURE';
type GET_SUGGESTIONS_FAILURE_TYPE = 'GET_SUGGESTIONS_FAILURE';

type SuggestionType = {
  term: string,
  priority: number,
  level: number,
  searchEnabled: boolean,
  lang: string,
  tenantId: string,
  id: string,
  weight: number
};

type GetSuggestionSuccess = {
  skip: number,
  limit: number,
  data: Array<SuggestionType>,
  total: number
};

type GetSuggestionsFailure = {
  error: any
};

type GetSuggestionsRequestAction = Action<GET_SUGGESTIONS_REQUEST_TYPE, null>;

type GetSuggestionsSuccessAction = Action<GET_SUGGESTIONS_SUCCESS_TYPE, GetSuggestionSuccess>;

type GetSuggestionsFailureAction = Action<GET_SUGGESTIONS_FAILURE_TYPE, GetSuggestionsFailure>;

// Bulk suggestions
export const BULK_SUGGESTIONS_REQUEST = 'BULK_SUGGESTIONS_REQUEST';
type BULK_SUGGESTIONS_REQUEST_TYPE = 'BULK_SUGGESTIONS_REQUEST';

export const BULK_SUGGESTIONS_SUCCESS = 'BULK_SUGGESTIONS_SUCCESS';
type BULK_SUGGESTIONS_SUCCESS_TYPE = 'BULK_SUGGESTIONS_SUCCESS';

export const BULK_SUGGESTIONS_FAILURE = 'BULK_SUGGESTIONS_FAILURE';
type BULK_SUGGESTIONS_FAILURE_TYPE = 'BULK_SUGGESTIONS_FAILURE';

type BulkSuggestionsRequestAction = Action<BULK_SUGGESTIONS_REQUEST_TYPE, null>;

type BulkSuggestionsSuccessAction = Action<BULK_SUGGESTIONS_SUCCESS_TYPE, BulkSuggestionSuccess>;

type BulkSuggestionsFailureAction = Action<BULK_SUGGESTIONS_FAILURE_TYPE, BulkSuggestionsFailure>;

// Delete suggestions
export const DELETE_SUGGESTIONS_REQUEST = 'DELETE_SUGGESTIONS_REQUEST';
type DELETE_SUGGESTIONS_REQUEST_TYPE = 'DELETE_SUGGESTIONS_REQUEST';

export const DELETE_SUGGESTIONS_SUCCESS = 'DELETE_SUGGESTIONS_SUCCESS';
type DELETE_SUGGESTIONS_SUCCESS_TYPE = 'DELETE_SUGGESTIONS_SUCCESS';

export const DELETE_SUGGESTIONS_FAILURE = 'DELETE_SUGGESTIONS_FAILURE';
type DELETE_SUGGESTIONS_FAILURE_TYPE = 'DELETE_SUGGESTIONS_FAILURE';

type DeleteSuggestionsRequestAction = Action<DELETE_SUGGESTIONS_REQUEST_TYPE, null>;

type DeleteSuggestionsSuccessAction = Action<
  DELETE_SUGGESTIONS_SUCCESS_TYPE,
  DeleteSuggestionsSuccess
>;

type DeleteSuggestionsFailureAction = Action<
  DELETE_SUGGESTIONS_FAILURE_TYPE,
  DeleteSuggestionsFailure
>;

// Update suggestion
export const UPDATE_SUGGESTION_REQUEST = 'UPDATE_SUGGESTION_REQUEST';
type UPDATE_SUGGESTION_REQUEST_TYPE = 'UPDATE_SUGGESTION_REQUEST';

export const UPDATE_SUGGESTION_SUCCESS = 'UPDATE_SUGGESTION_SUCCESS';
type UPDATE_SUGGESTION_SUCCESS_TYPE = 'UPDATE_SUGGESTION_SUCCESS';

export const UPDATE_SUGGESTION_FAILURE = 'UPDATE_SUGGESTION_FAILURE';
type UPDATE_SUGGESTION_FAILURE_TYPE = 'UPDATE_SUGGESTION_FAILURE';

type UpdateSuggestionRequestAction = Action<UPDATE_SUGGESTION_REQUEST_TYPE, null>;

type UpdateSuggestionSuccessAction = Action<
  UPDATE_SUGGESTION_SUCCESS_TYPE,
  UpdateSuggestionSuccess
>;

type UpdateSuggestionFailureAction = Action<
  UPDATE_SUGGESTION_FAILURE_TYPE,
  UpdateSuggestionFailure
>;

// Vefify csv file before importing
export const VERIFY_CONTENT_BEFORE_IMPORT_REQUEST = 'VERIFY_CONTENT_BEFORE_IMPORT_REQUEST';
type VERIFY_CONTENT_BEFORE_IMPORT_REQUEST_TYPE = 'VERIFY_CONTENT_BEFORE_IMPORT_REQUEST';

export const VERIFY_CONTENT_BEFORE_IMPORT_SUCCESS = 'VERIFY_CONTENT_BEFORE_IMPORT_SUCCESS';
type VERIFY_CONTENT_BEFORE_IMPORT_SUCCESS_TYPE = 'VERIFY_CONTENT_BEFORE_IMPORT_SUCCESS';

export const VERIFY_CONTENT_BEFORE_IMPORT_FAILURE = 'VERIFY_CONTENT_BEFORE_IMPORT_FAILURE';
type VERIFY_CONTENT_BEFORE_IMPORT_FAILURE_TYPE = 'VERIFY_CONTENT_BEFORE_IMPORT_FAILURE';

type VerifyContentBeforeImportRequestAction = Action<
  VERIFY_CONTENT_BEFORE_IMPORT_REQUEST_TYPE,
  null
>;

type VerifyContentBeforeImportSuccessAction = Action<
  VERIFY_CONTENT_BEFORE_IMPORT_SUCCESS_TYPE,
  VerifyContentBeforeImportSuccess
>;

type VerifyContentBeforeImportFailureAction = Action<
  VERIFY_CONTENT_BEFORE_IMPORT_FAILURE_TYPE,
  VerifyContentBeforeImportFailure
>;

// Import file
export const IMPORT_FILE_REQUEST = 'IMPORT_FILE_REQUEST';
type IMPORT_FILE_REQUEST_TYPE = 'IMPORT_FILE_REQUEST';

export const IMPORT_FILE_SUCCESS = 'IMPORT_FILE_SUCCESS';
type IMPORT_FILE_SUCCESS_TYPE = 'IMPORT_FILE_SUCCESS';

export const IMPORT_FILE_FAILURE = 'IMPORT_FILE_FAILURE';
type IMPORT_FILE_FAILURE_TYPE = 'IMPORT_FILE_FAILURE';

type ImportFileRequestAction = Action<IMPORT_FILE_REQUEST_TYPE, null>;

type ImportFileSuccessAction = Action<IMPORT_FILE_SUCCESS_TYPE, ImportFileSuccess>;

type ImportFileFailureAction = Action<IMPORT_FILE_FAILURE_TYPE, ImportFileFailure>;

// Export file
export const EXPORT_FILE_REQUEST = 'EXPORT_FILE_REQUEST';
type EXPORT_FILE_REQUEST_TYPE = 'EXPORT_FILE_REQUEST';

export const EXPORT_FILE_SUCCESS = 'EXPORT_FILE_SUCCESS';
type EXPORT_FILE_SUCCESS_TYPE = 'EXPORT_FILE_SUCCESS';

export const EXPORT_FILE_FAILURE = 'EXPORT_FILE_FAILURE';
type EXPORT_FILE_FAILURE_TYPE = 'EXPORT_FILE_FAILURE';

type ExportFileRequestAction = Action<EXPORT_FILE_REQUEST_TYPE, null>;

type ExportFileSuccessAction = Action<EXPORT_FILE_SUCCESS_TYPE, ExportFileSuccess>;

type ExportFileFailureAction = Action<EXPORT_FILE_FAILURE_TYPE, ExportFileFailure>;

// Action and State
export type SuggestionsAction =
  | GetSuggestionsRequestAction
  | GetSuggestionsSuccessAction
  | GetSuggestionsFailureAction
  | BulkSuggestionsRequestAction
  | BulkSuggestionsSuccessAction
  | BulkSuggestionsFailureAction
  | DeleteSuggestionsRequestAction
  | DeleteSuggestionsSuccessAction
  | DeleteSuggestionsFailureAction
  | UpdateSuggestionRequestAction
  | UpdateSuggestionSuccessAction
  | UpdateSuggestionFailureAction
  | VerifyContentBeforeImportRequestAction
  | VerifyContentBeforeImportSuccessAction
  | VerifyContentBeforeImportFailureAction
  | ImportFileRequestAction
  | ImportFileSuccessAction
  | ImportFileFailureAction
  | ExportFileRequestAction
  | ExportFileSuccessAction
  | ExportFileFailureAction;

export type SuggestionsState = {
  loading: boolean,
  success: boolean,
  successFlag: number,
  error: null,
  suggestions: Array<SuggestionType> | [],
  total: number,
  saving: boolean,

  // Verify file content
  verifying: boolean,
  fileContentErrorCode: string,
  totalRecord: number,

  // Import file content
  importing: boolean,
  totalImportedRecords: number
};
